import { render, staticRenderFns } from "./AvailableTextbookForm.vue?vue&type=template&id=78e91187&scoped=true&"
import script from "./AvailableTextbookForm.vue?vue&type=script&lang=js&"
export * from "./AvailableTextbookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e91187",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
